<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div id="cronJobConfiguration">
      <mat-card-content style="padding-left: 40px;">
        <h4>{{'organization.create.section_4.frequency' | translate}}</h4>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="35">
            <mat-form-field id="matFrmFieldSelectCronTime" class="mat-block">
              <input
                id="txtTimeFrequency"
                matInput
                type="time"
                [required]="isRequired('multipleTimeFrequency')"
                formControlName="multipleTimeFrequency"
                placeholder="Time (UTC)"
              />
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.monday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="mondayKey" formControlName="monday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.tuesday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="tuesdayKey" formControlName="tuesday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.wednesday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="wednesdayKey" formControlName="wednesday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.thursday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="thursdayKey" formControlName="thursday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.friday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="fridayKey" formControlName="friday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.saturday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="saturdayKey" formControlName="saturday"> </mat-slide-toggle>
          </div>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="20px Grid" class="u-margin-top-15">
          <div fxFlex="100" fxFlex.gt-sm="30" fxLayoutAlign="start center">
            {{ "organization.create.section_4.weekdays.sunday" | translate }}
          </div>
          <div fxFlex="100" fxFlex.gt-sm="25" class="u-margin-top-10 u-margin-left-15">
            <mat-slide-toggle [id]="sundayKey" formControlName="sunday"> </mat-slide-toggle>
          </div>
        </div>
      </mat-card-content>
    </div>
  </div>
</div>
